﻿$(function () {

    var views = [];

    // TODO: This should be refactored out of this file
    var navbarHeight = $('.navbar').height();

    var logViewsTimeoutId = null;

    function queueLogViews() {
        if (logViewsTimeoutId !== null) {
            window.clearTimeout(logViewsTimeoutId);
        }

        logViewsTimeoutId = window.setTimeout(function () {

            $.ajax('/instrumentation/logviews',
                {
                    type: 'POST',
                    async: true,
                    cache: false,
                    contentType: "application/json",
                    processData: false,
                    data: JSON.stringify({
                        'views': views
                    }),
                    success: function () {
                        // Do nothing
                    }
                });

            // Reset the list
            views = [];
        }, 1000);
    }

    function isElementInViewport(el) {

        // Special bonus for those using jQuery
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return (
            Math.floor(rect.top) >= navbarHeight &&
            Math.floor(rect.left) >= 0 &&
            Math.floor(rect.bottom) <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
            Math.floor(rect.right) <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
        );
    }

    function onVisibilityChange(el, callback) {
        var old_visible;
        return function () {
            var visible = isElementInViewport(el);
            if (visible != old_visible) {
                old_visible = visible;
                if (typeof callback == 'function') {
                    callback();
                }
            }
        }
    }


    // Get all elements that should be instrumented
    const $instrumentedElems = $('[data-instrument]');

    $instrumentedElems.each(function (idx, elem) {
        var handler;
        handler = onVisibilityChange(elem, function () {
            const elementInViewport = isElementInViewport(elem);
            if (elementInViewport) {

                // Get all data attrs
                const allData = $(elem).data();

                const subject = allData.instrument;

                if (!subject) {
                    return;
                }

                const instrumentKeys = Object.keys(allData).filter((key) => key.indexOf('instrument') !== -1 && key !== 'instrument');


                let meta = {};
                for (var idx in instrumentKeys) {
                    const key = instrumentKeys[idx];
                    meta[key.replace(/^instrument/, '')] = allData[key];
                }

                views.push({
                    subject,
                    meta
                });

                // Record the contender views
                queueLogViews();

                // Remove the handled for this specific element so this element
                // does not get sent into the views
                $(window).off('resize scroll', handler);
            }
        });


        // jQuery
        $(window).on('resize scroll', handler);

        // Delay a little bit and then forcefully
        // fire the handler to see if the content is in the viewport. We
        // need to do this sometimes because of timing issues with the $(window).on()
        // call about that 
        window.setTimeout(handler, 800);
    });
        
});